import { useMutation } from "@tanstack/react-query";
import { sendReview } from "@src/entities/rating/api/request/sendReview";
import { useNotificationStore } from "@src/shared/components/Notification";

export const useSendReview = () => {
  const { showAlert } = useNotificationStore();
  const query = useMutation({
    mutationFn: sendReview,
     onSuccess: () => {
      showAlert("Благодарим за ваш отзыв", "success");
    },
    onError: (error) => {
      showAlert(error.message, "error");
    },
  });
  return query;
};
